import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { RejectReasonComponent } from '../reject-reason/reject-reason.component';
import * as FileSaver from 'file-saver';
import { DescriptionDetailsComponent } from '../description-details/description-details.component';

@Component({
  selector: 'app-incubator-approval',
  templateUrl: './incubator-approval.component.html',
  styleUrls: ['./incubator-approval.component.css'],
})
export class IncubatorApprovalComponent implements OnInit {
  displayedColumns: string[] = [
    'index',
    'incubatorName',
    'incubatorPhone',
    'uniqueId',
    'incubatorEmail',
    'incubatorRegDesc',
    'incubatorRegistrationType',
    'incubatorRegFileName',
    'incubatorStatusUpdatedDate',
    'reason',
    'action',
  ];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  private saveApi = environment.url + environment.incubatorApprovalSave;
  private listApi = environment.url + environment.incubatorApprovalList;
  private excelDownload = environment.url + environment.excelDownload;
  private removeApi = environment.url + environment.incubatorRemove;
  activeTab: string | null = null;
  /**
   * Constructor for the IncubatorApprovalComponent.
   * @param makeapi The API service provider.
   * @param getdata The Value service provider.
   * @param notify The Notification service provider.
   * @param dialog The Material dialog service provider.
   */
  constructor(
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {
    /**
     * Initialize the MatTableDataSource with empty data.
     */
    this.dataSource = new MatTableDataSource();
  }

  roleValue;
  /**
   * Initialize the component by setting the role value and fetching the incubatee list.
   */
  ngOnInit(): void {
    // Set the visibility of the loading indicator
    this.getdata.isVisibleSource.next(true);

    // Retrieve the user's role from session storage
    this.roleValue = sessionStorage.getItem('role');

    // Initialize the flag to indicate if data is available
    this.noData = false;

    // Fetch the list of incubatees
    this.incubatorList();
  }
  /**
   * Shows the content of a tab based on the given id.
   * @param tabId The id of the tab to show.
   */
  showTabContent(tabId: string) {
    this.activeTab = tabId;
  }
  incubatorUserId;
  /**
   * Shows the edit modal dialog for the given incubator user id.
   * @param id The id of the incubator user to edit.
   */
  modalOpen(id) {
    // Set the incubator user id to edit
    this.incubatorUserId = id;
    // Show the edit modal dialog
    document.getElementById('editModals').style.display = 'block';
  }
  /**
   * Shows the pending modal dialog for the given incubator user id.
   * @param id The id of the incubator user to set as pending.
   */
  pendingModalOpen(id: number) {
    // Set the incubator user id to set as pending
    this.incubatorUserId = id;
    // Show the pending modal dialog
    document.getElementById('PendingModals').style.display = 'block';
  }
  /**
   * Saves the changes made to the incubator user's data in the edit modal dialog.
   */
  saveModal() {
    // Create the request object to save the incubator user's data
    let req = {
      incubatorUserId: this.incubatorUserId,
      status: 1,
    };

    // Make the API call to save the incubator user's data
    this.makeapi.method(this.saveApi, req, 'post').subscribe((data) => {
      if (data.responseStatus == 'Success') {
        // Show a success notification
        this.notify.notifysuccess(data.responseMessage);

        // Refetch the list of incubatees
        this.incubatorList();

        // Hide the loading indicator
        this.getdata.isVisibleSource.next(true);

        // Hide the edit modal dialog
        document.getElementById('editModals').style.display = 'none';
      } else {
        // Show an error notification
        this.notify.notifyError(data.responseMessage);
      }
    });
  }
  /**
   * Saves the pending status for the incubator user and closes the pending modal.
   * Sends a request to update the status of the incubator user to pending.
   */
  pendingSaveModal() {
    // Create the request object to update the incubator user's status to pending
    let req = {
      incubatorUserId: this.incubatorUserId,
      status: 0,
    };

    // Make the API call to update the incubator user's status
    this.makeapi.method(this.saveApi, req, 'post').subscribe((data) => {
      if (data.responseStatus == 'Success') {
        // Show a success notification
        this.notify.notifysuccess(data.responseMessage);

        // Refetch the list of incubatees
        this.incubatorList();

        // Hide the pending modal dialog
        this.getdata.isVisibleSource.next(true);
        document.getElementById('PendingModals').style.display = 'none';
      } else {
        // Show an error notification
        this.notify.notifyError(data.responseMessage);
      }
    });
  }
  list = {};
  disList: any = [];
  pageTotalCount: number;
  pageSize: number = 25;
  pageNumber: number = 1;
  status = 0;
  noData = true;
  /**
   * Updates the status, resets pagination, and fetches the list of incubatees.
   * @param val The new status value to be set.
   */
  incubatorCheck(val) {
    // Set the status value
    this.status = val;

    // Reset the page number and page size for pagination
    this.pageNumber = 1;
    this.pageSize = 25;

    // Fetch the updated list of incubatees
    this.incubatorList();
  }
  /**
   * Fetches the list of incubatees based on pagination and status.
   * Displays a loading indicator during the API request.
   * Updates component data with the API response.
   * Sets the noData flag if the response contains no data.
   */
  incubatorList() {
    // Display the loading indicator
    this.getdata.amizhthLoader('show');

    // Make an API call to fetch the incubatee list
    return this.makeapi
      .method(
        `${this.listApi}?listSize=${this.pageSize}&pageNumber=${this.pageNumber}&status=${this.status}`,
        '',
        'get'
      )
      .subscribe((data) => {
        // Hide the loading indicator
        this.getdata.amizhthLoader('hide');

        // Check if there is no data returned
        if (data.count === 0) {
          this.noData = true;
        } else {
          // Data is available
          this.noData = false;
          // Update the total count of items
          this.pageTotalCount = data.count;
          // Update the list of incubatees
          this.disList = data.approvalPendingUsers;
          // Set the MatTableDataSource with the list of incubatees
          this.dataSource = new MatTableDataSource(data.approvalPendingUsers);
        }
      });
  }
  /**
   * Lifecycle hook that is called after the component's view has been fully initialized.
   * Sets the paginator for the MatTableDataSource.
   */
  ngAfterViewInit() {
    // Assign the paginator to the data source for pagination functionality
    this.dataSource.paginator = this.paginator;
  }
  /**
   * Handles the pagination event and updates the data accordingly.
   * @param event - The pagination event containing the page index and page size.
   */
  getServerData(event) {
    // Update the page number and page size based on the pagination event
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;

    // Fetch the updated list of incubatees based on the new pagination data
    this.incubatorList();
  }
  /**
   * Opens the RejectReason dialog and handles the result.
   * @param id The ID of the incubator to reject.
   */
  rejectReason(id) {
    // Open the RejectReason dialog with specific configurations
    const dialogRef = this.dialog.open(RejectReasonComponent, {
      width: '390px',
      data: { _id: id },
    });

    // Handle the dialog's closed event
    dialogRef.afterClosed().subscribe((result) => {
      // Refresh the list of incubatees
      this.incubatorList();
      // Notify that data visibility has been updated
      this.getdata.isVisibleSource.next(true);
    });
  }
  /**
   * Downloads the incubator list as an Excel file.
   * Shows a loading indicator during the request and hides it once the file is downloaded.
   * The file is saved with a name based on the current date and time.
   * @param name The name of the incubator list
   * @param value The value of the incubator list to be downloaded
   */
  downloadExcel(name: string, value: string) {
    // Show loading indicator
    this.getdata.amizhthLoader('show');

    // Make API call to download the Excel file
    this.makeapi
      .method(this.excelDownload + value, '', 'download')
      .subscribe((data) => {
        // Hide loading indicator
        this.getdata.amizhthLoader('hide');

        // Generate the current date and time for the filename
        const date = new Date();
        let currentDate = `${date.getFullYear()}-${
          date.getMonth() + 1
        }-${date.getDate()}-${date.getSeconds()}`;

        // Define the filename with the current date and time
        let filename =
          'StartupTN_Incubators_' + name + '_' + currentDate + '.xlsx';

        // Save the downloaded file using FileSaver
        FileSaver.saveAs(data, filename);
      });
  }
  /**
   * Opens the DescriptionDetails dialog and handles the result.
   * @param status The status associated with the description.
   * @param title The title of the description.
   */
  viewDescrptionBtn(status: string, title: string) {
    // Open the DescriptionDetails dialog with the provided status and title
    const dialogRef = this.dialog.open(DescriptionDetailsComponent, {
      width: '390px',
      data: { _status: status, _title: title },
    });

    // Handle the dialog's closed event
    dialogRef.afterClosed().subscribe((result) => {});
  }
  /**
   * Hides the edit modal by setting its display property to 'none'.
   */
  closeModal(): void {
    document.getElementById('editModals').style.display = 'none';
  }
  /**
   * Hides the pending modal by setting its display property to 'none'.
   */
  pendingCloseModal(): void {
    // Hide the pending modal
    document.getElementById('PendingModals').style.display = 'none';
  }
  expandedRow: { [key: string]: boolean } = {};

  /**
   * Toggles the read-more state for the given incubator name.
   * Expands or collapses the additional text based on the current state.
   * @param incubatorName The name of the incubator which text needs to be toggled.
   */
  toggleReadMore(incubatorName: string) {
    // Toggle the current state of the read-more flag for the incubatorName
    this.expandedRow[incubatorName] = !this.expandedRow[incubatorName];
  }
}
